<script lang="ts">
	import { nbspify } from "../../../../core/utils/nbspify";
	import type { CakeProps } from "../../templates/CustomCakesProps";
	import Banner from "../Banner.svelte";
	import Slider from "../Slider.svelte";
	import CustomCakeCardSm from "./CustomCakeCardSm.svelte";
	import fruityWhiteFillingImg from "../../assets/images/custom-cakes/fillings/fruity-white.jpg?w=288&webp&imagetools";
	import fruityDarkFillingImg from "../../assets/images/custom-cakes/fillings/fruity-dark.jpg?w=288&webp&imagetools";
	import lemonRaspberryFillingImg from "../../assets/images/custom-cakes/fillings/lemon-raspberry.jpg?w=288&webp&imagetools";
	import chocoRaspberryFillingImg from "../../assets/images/custom-cakes/fillings/choco-raspberry.jpg?w=288&webp&imagetools";
	import buenoFillingImg from "../../assets/images/custom-cakes/fillings/bueno.jpg?w=288&webp&imagetools";
	import pistachioRaspberryFillingImg from "../../assets/images/custom-cakes/fillings/pistachio-raspberry.jpg?w=288&webp&imagetools";
	import staticBannerFillingImgSm from "../../assets/images/custom-cakes/fillings/banner-filling.jpg?w=400&webp&imagetools";
	import staticBannerFillingImgMd from "../../assets/images/custom-cakes/fillings/banner-filling.jpg?w=432&webp&imagetools";
	import staticBannerFillingImgLg from "../../assets/images/custom-cakes/fillings/banner-filling.jpg?w=496&webp&imagetools";

	const fillings: CakeProps[] = [
		{ desc: ["ovocný - světlý"], image: fruityWhiteFillingImg },
		{ desc: ["ovocný - tmavý"], image: fruityDarkFillingImg },
		{ desc: ["citronový s malinami"], image: lemonRaspberryFillingImg },
		{ desc: ["čokoládový s malinami"], image: chocoRaspberryFillingImg },
		{ desc: ["Bueno"], image: buenoFillingImg },
		{ desc: ["Pistáciový s malinami"], image: pistachioRaspberryFillingImg },
	];
</script>

<Banner
	headline="Náplň dortu"
	subHeadline="Samozřejmě, že dort musí nejen skvěle vypadat, ale i chutnat!"
	image={{
		alt: "Fotografie – ukázka náplně dortu",
		sizes: { sm: staticBannerFillingImgSm, md: staticBannerFillingImgMd, lg: staticBannerFillingImgLg },
	}}
>
	<p>
		{nbspify("Naše kombinace osloví jak milovníky lehkých ovocných dortů, tak i nadšence do čokolády.")}
	</p>
	<p>
		{nbspify(
			"Sázka na jistotu je náš ovocný světlý. Touto oblíbenou kombinací čerstvého ovoce a lehkého krému z mascarpone, tvarohu a šlehačky se trefíte do chuti menším dětem i dospělým.",
		)}
	</p>
</Banner>
<Slider items={fillings}>
	{#each fillings as item, index}
		<CustomCakeCardSm {item} {index} />
	{/each}
</Slider>
